<template>
  <div>
    <div class="main" style="margin-top: 5px;">
      <div class="n-left-nav" style="width: 200px;">
        <div class="navTitle">
          交易项目
        </div>
        <div class="m-nav-list" style="width: 160px;">
          <router-link :to="{name:'transferList'}">
            <div class="typeNav ">转让项目</div>
          </router-link>
          <router-link :to="{name:'demandList'}">
            <div class="typeNav ">需求项目</div>
          </router-link>
          <router-link :to="{name:'procureList'}"  class="typeNav">
            <div   class="typeNav ">采购项目</div>
          </router-link>
          <router-link :to="{name:'doneDealList'}">
            <div class="typeNav">成交公告</div>
          </router-link>

          <router-link :to="{name:'verifyList'}">
            <div class="typeNav activeSelectType">鉴证公示</div>
          </router-link>
        </div>
      </div>
      <div class="page-right" style="width: 980px;border: 1px solid #e4e4e4;margin-top: 20px;margin-right: 20px">
        <div class="pagelujing">
          <div class="name" style="padding-left: 5px;"> <a href="#">鉴证公示</a>&nbsp; </div>

        </div>
        <div class="news-txt ny mg-t-b">

          <div style="width: 96%;height: 40px;line-height: 40px;">
            <div class="searchPer" style="width:21%">
              <div class="searchPer_left">县/区:</div>
              <div class="searchPer_right">
                <span v-if="countys.length<2">{{unitName}}</span>
                <select  style="height: 35px;width: 100%;" v-model="countyUnitCode" @change="getTowns()" v-if="countys.length>1">
                	<option :value="unitCode" >全部</option>
                	<option :value="item.unitCode" v-for="(item,index) in countys">{{item.name}}</option>
                </select>
              </div>
            </div>
            <div class="searchPer" style="margin-left: 1%;">
              <div class="searchPer_left">乡/街道:</div>
              <div class="searchPer_right">
                <select style="height: 35px;width: 100%;" v-model="townUnitCode" @change="getVillages()">
                  <option :value="item.unitCode" v-for="(item,index) in towns">{{item.name}}</option>
                </select>
              </div>
            </div>
            <div class="searchPer" style="margin-left: 1%;">
              <div class="searchPer_left">村/社区:</div>
              <div class="searchPer_right">
                <select style="height: 35px;width: 100%;" v-model="villageUnitCode" @change="selectVillageUnitCode()">
      			         <option :value="item.unitCode" v-for="(item,index) in villages">{{item.name}}</option>
                </select>
              </div>
            </div>
            <div class="searchPer" style="width:20%">
              <div class="searchPer_left">关键字:</div>
              <div class="searchPer_right">
                <input type="text" style="height: 35px;width: 100%;" v-model="itemName" />

              </div>
            </div>

            <div class="searchPer" style="width:7%">
              <div class="searchPer_right" style="width:100%">
                <button class="btn-search"style="width:100%" @click="getDatas()">查询</button>
              </div>

            </div>
          </div>






          <div class="news-con">
      			   <div class="title">

      		      <div class="title_perName" style="width: 80%;">
                项目名称
              </div>
              <div class="title_perDate">
                发布时间
              </div>

            </div>

            <div class="perContent" v-for="(trade, index) in trades">
              <a @click="jump(trade.transferId)" style="cursor:pointer;color: black;">

                <div class="title_perName"  style="width: 80%;">
                  {{trade.title}}
                </div>

                <div class="title_perDate">

              {{trade.updateTime.substr(0,10)}}
      					  </div>
              </a>


            </div>

       		 </div>
       	</div>
        <div class="" style="width: 100%;height: 40px;text-align: center;">
          <div class="tabListPage">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
              :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        trades: [],
        pageNum: 1, // 默认显示第几页
        totalCount: 0, // 总条数，根据接口获取数据长度(注意：这里不能为空)
        pageSizes: [5, 10, 15, 20], // 个数选择器（可修改）
        pageSize: 10, // 默认每页显示的条数（可修改）
        type: "",
        pathUrl: "",
        typeName: "",
        tradeType: "",
        unitCode: localStorage.getItem("unitCode"),
        unitName:localStorage.getItem("unitName"),
        countys: [],
        towns: [],
        villages: [],
        countyUnitCode: "",
        townUnitCode: "",
        villageUnitCode: "",
        selectUnitCode: localStorage.getItem("unitCode"),

        selectType: "", //类别查询
        selectAreaNum: "", //面积查询
        itemNum: "", //项目编号
        itemName: "", //项目名称

      }
    },
    mounted() {

      this.getDatas();
   	  this.getCountys();
        this.countyUnitCode=localStorage.getItem("unitCode");
      this.getTowns();
    },
    methods: {

      async getDatas() {

        const {
          data: res
        } = await this.$http.get("/web/getAuthentication?pageNum=" + this.pageNum + "&pageSize=9&unitCode=" + this
          .selectUnitCode);
        this.trades = res.data.list;
        console.log(this.trades)
        this.totalCount = res.data.total;


      },
      async getCountys() {
        const action = "/web/unitCode/getXians/" + this.unitCode;
        const {
          data: res
        } = await this.$http.get(action);
        this.countys = res.data;
      },
      async getTowns() {
        const action = "/web/unitCode/getXiangs/" + this.countyUnitCode;
   	    const {
          data: res
        } = await this.$http.get(action);
        this.selectUnitCode = this.countyUnitCode;
        this.towns = res.data;
          this.getDatas();
      },
      async getVillages() {
        const action = "/web/unitCode/getCuns/" + this.townUnitCode;
        const {
          data: res
        } = await this.$http.get(action);
        this.selectUnitCode = this.townUnitCode;
        this.villages = res.data;
          this.getDatas();
   	  },
      selectVillageUnitCode() {
        this.selectUnitCode = this.villageUnitCode;

   	  },
      handleSizeChange(val) { // 每页显示的条数，选择每页条数的时候执行
        console.log("handleSizeChange")
        this.pageSize = val // 改变每页显示的条数
        this.getDatas() // 点击每页显示的条数时，显示第一页
        this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
      },
      // 显示第几页
      handleCurrentChange(val) {
        this.pageNum = val; // 改变默认的页数
        this.getDatas() // 切换页码时，要获取每页显示的条数
      },
      handleClose(done) {
        done();
      },
      jump(ids) {

        let routeUrl = this.$router.resolve({
          path: "/verifyDetail",
          query: {
            id: ids
          }
        });
        window.open(routeUrl.href, '_blank');
      },
    }


  };
</script>

<style scoped="">
  @import url("../../../assets/css/index.css");
  @import url("../../../assets/css/base.css");
  @import url("../../../assets/css/main.css");
  @import url("../../../assets/css/news.css");

  .navTitle {
    border-bottom: 1px solid #f6f6f6;
    text-align: center;
    height: 50px;
    line-height: 50px;
    width: 200px;
    background-color: #f6f6f6;
    font-size: 20px;

  }

  .activeSelectType {
    background-color: #4cb050;
    color: white;

  }

  .per {
    width: 98%;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #9796a72e;
    cursor: pointer;
  }

  .typeNav {
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    border-bottom: 1px solid #f6f6f6;
  }

  .searchPer_right select {
    width: 100%;
  }

  .hone-container {
    height: 100%;
  }

  a-layout-content {
    height: 100%;
  }

  .ant-layout-header {
    /* 2850A0 */
    padding: 0px;
    background-color: #3c8dbc !important;
  }

  .main {
    width: 1220px;
    margin: 0 auto;
    height: auto;
    overflow: hidden;
    background-color: white;
    margin-top: 5px;
    min-height: 800px;
  }

  .title {
    width: 100%;
    height: 35px;
    line-height: 35px;
    background-color: #f6f6f6;
    margin-top: 15px;

  }

  .title_per {
    width: 15%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    float: left;
    font-size: 16px;
  }

  .title_perName {
    width: 60%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    float: left;
    font-size: 16px;
    text-overflow:ellipsis;
     white-space:nowrap;
  }

  .title_perDate {
    width: 12%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    float: left;
    font-size: 16px;


  }

  .perContent:nth-child(odd) {
    width: 100%;
  	 height: 35px;
  	 line-height: 35px;
    background-color: #f6f6f6;
    text-align: center;
  }

  .perContent:nth-child(even) {
    width: 100%;
  	 height: 35px;
    line-height: 35px;
  	 background-color: #FFFFFF;
    text-align: center;
  }

  .searchPer {

    width: 25%;
    height: 40px;
    float: left;
    text-align: left;
    font-size: 16px;
  }

  .searchPer_left {
    width: 30%;
    text-align: right;
    height: 30px;
    float: left;
  }

  .searchPer_right {
    width: 70%;
    height: 30px;
    float: left;
  }

  .searchPer_right select {
    display: inline-block;

    border: solid 1px #eeeeee;
    width: 165px;
    margin-left: 6px;
    height: 30px;
  }

  .searchPer_right input {
    display: inline-block;

    border: solid 1px #eeeeee;
    width: 165px;
    margin-left: 6px;
    height: 30px;
  }

  .btn-search {
    background-color: #4cb050;
    color: #ffffff;
    display: inline-block;
    text-align: center;
    margin-left: 20px;
    height: 38px;
    width: 170px;
    cursor: pointer;
    border: 1px solid #4cb050;
  }
</style>
